import { CSSTransition, TransitionGroup } from "react-transition-group";

function Comment(props) {
    return (
        <div className="row mt-30 round-box-2">
            <div className="col-12">
                <div className="comment-area mb-5">
                    {props.comments ? (
                        <h5 className="mb-5">
                            <i className="icofont-comment purple-icon" />
                            {props.comments.length || "0"}개의 댓글이 있습니다.{" "}
                        </h5>
                    ) : (
                        <h5 className="mb-5">
                            <i className="icofont-comment purple-icon" />
                            첫번째 댓글을 등록해 주세요.
                        </h5>
                    )}

                    <TransitionGroup
                        component="ul"
                        className="comment-tree list-unstyled"
                    >
                        {props.comments.map((comment, idx) => (
                            <CSSTransition
                                key={idx}
                                timeout={700}
                                classNames="transition-item"
                            >
                                <li className="mb-5">
                                    <div className="comment-area-box">
                                        <div className="comment-info">
                                            <ul className="tag-option">
                                                <li className="list-inline-item">
                                                    <h5 className="mb-1">
                                                        {comment.writer} ({comment.userid})
                                                    </h5>
                                                </li>
                                                {props.userType === "0" ||
                                                    props.userId === comment.userid ? (
                                                    <>
                                                        <li className="list-inline-item">
                                                            <span
                                                                onClick={(e) => {
                                                                    props.fnCommentEdit(comment.cserial, true);
                                                                }}
                                                            >
                                                                수정
                                                            </span>
                                                        </li>
                                                        <li className="list-inline-item">
                                                            <span
                                                                onClick={(e) => {
                                                                    props.fnCommentDelete(comment.cserial);
                                                                }}
                                                            >
                                                                삭제
                                                            </span>
                                                        </li>
                                                    </>
                                                ) : null}
                                            </ul>

                                            <span className="date-comm">Posted {comment.wdate}</span>
                                        </div>

                                        {comment.isEdit ? (
                                            <div className="input-group">
                                                <textarea
                                                    id={`comment_${comment.cserial}`}
                                                    className="form-control custom-control text-reply"
                                                    rows="2"
                                                    maxLength="2000"
                                                    defaultValue={comment.comment}
                                                ></textarea>
                                                <span
                                                    className="input-group-addon btn btn-light btn-reply"
                                                    onClick={(e) => {
                                                        props.fnCommentEditClick(comment.cserial);
                                                    }}
                                                >
                                                    수정
                                                </span>
                                                <span
                                                    className="input-group-addon btn btn-light btn-reply"
                                                    onClick={(e) => {
                                                        props.fnCommentEdit(comment.cserial, false);
                                                    }}
                                                >
                                                    취소
                                                </span>
                                            </div>
                                        ) : (
                                            <div className="comment-content mt-3">
                                                <p>
                                                    {comment.comment.split("\n").map((line, idx) => {
                                                        return (
                                                            <span key={idx}>
                                                                {line}
                                                                <br />
                                                            </span>
                                                        );
                                                    })}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            </CSSTransition>
                        ))}
                    </TransitionGroup>
                </div>
            </div>

            <div className="col-12 ">
                <p>
                    <i className="icofont-notification" />
                    &nbsp;
                    <span style={{ color: "#000" }}>
                        댓글 작성시 타인에 대한 배려와 책임을 담아주세요.
                    </span>
                </p>
                <textarea
                    className="form-control mb-4"
                    name="comment"
                    id="comment"
                    cols="30"
                    rows="3"
                    placeholder={
                        props.userId ? "내용을 입력해 주세요." : "로그인 후 이용해 주세요."
                    }
                    onChange={(e) => {
                        props.setComment(e.target.value);
                    }}
                    style={{
                        resize: "none",
                    }}
                    maxLength="2000"
                    disabled={!props.userId}
                ></textarea>

                {props.userId ? (
                    <input
                        className="btn btn-main-2 btn-round-full"
                        type="submit"
                        name="submit-contact"
                        id="submit_contact"
                        value="댓글달기"
                        onClick={props.fnCommentClick}
                    />
                ) : null}
            </div>
        </div>
    );
}

export default Comment;
